import React from "react";
import { Preview } from "@mui/icons-material";
import { IconButton, Tooltip } from "@mui/material";
import { Link } from "react-router-dom";
import { Campaign, User } from "../../types";

export interface Props {
  campaign: Campaign;
  user: User;
  disabled?: boolean;
}

export const PreviewButton = ({ campaign, user, disabled }: Props) => {
  return (
    <Tooltip title={disabled ? "" : "Preview as Student"}>
      <span>
        <IconButton
          edge="end"
          aria-label="result preview"
          disabled={disabled}
          {...(!disabled && {
            component: Link,
            to: `/results/preview/${campaign.id}/${user.id}/campaign`,
          })}
        >
          <Preview />
        </IconButton>
      </span>
    </Tooltip>
  );
};
